import { useMemo } from 'react';
import classNamesHelper from 'classnames';
export const useClassName = (...classNames) => {
    const className = useMemo(() => {
        return classNamesHelper(...classNames.map((className) => {
            if (!className)
                return '';
            if (typeof className === 'object') {
                const { name, prefixed } = className;
                return prefixed ? `ds_${name}` : name;
            }
            return className;
        }));
    }, classNames);
    return className;
};
